import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowWallLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-wall-left, align left"} maskId="square-filled-radius-0-stroke-1-IconArrowWallLeft"><path fillRule="evenodd" clipRule="evenodd" d="M3 4V20H2V4H3ZM11.9571 7.25L7.70711 11.5H22V12.5H7.7071L11.9571 16.75L11.25 17.4571L5.79289 12L11.25 6.54289L11.9571 7.25Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowWallLeft;
